import { Outlet } from 'react-router-dom';
import { useState, createContext, useContext } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileNav from './MobileNav';
import UpdatePrompt from './UpdatePrompt';
import OfflineBanner from './OfflineBanner';
import TourOverlay from '../tutorial/TourOverlay';

interface SidebarContextType {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
}

const SidebarContext = createContext<SidebarContextType>({
  isOpen: false,
  toggle: () => {},
  close: () => {},
});

export const useSidebar = () => useContext(SidebarContext);

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const sidebarContext: SidebarContextType = {
    isOpen: sidebarOpen,
    toggle: () => setSidebarOpen(!sidebarOpen),
    close: () => setSidebarOpen(false),
  };

  return (
    <SidebarContext.Provider value={sidebarContext}>
      <div className="flex h-screen bg-slate-100 dark:bg-slate-900">
        <UpdatePrompt />

        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <Sidebar />

        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <OfflineBanner />
          <main className="flex-1 overflow-y-auto p-4 sm:p-6 pb-28 lg:pb-6">
            <Outlet />
          </main>
        </div>

        <MobileNav />
        <TourOverlay />
      </div>
    </SidebarContext.Provider>
  );
}
